import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {FormFieldTextInputSchema} from './formFieldTextInput'
import {FormFieldTextAreaSchema} from './formFieldTextArea'
import {FormFieldSelectSchema} from './formFieldSelect'
import {FormFieldCheckboxGroupSchema} from './formFieldCheckboxGroup'

export const TwoColumnFormLayoutSchema = buildEntrySchemaFor('twoColumnFormLayout', {
  fields: z.lazy(() =>
    z.object({
      rows: z
        .array(
          buildEntrySchemaFor('row', {
            fields: z.lazy(() =>
              z.object({
                fields: z
                  .array(
                    z
                      .union([
                        FormFieldTextInputSchema,
                        FormFieldTextAreaSchema,
                        FormFieldCheckboxGroupSchema,
                        FormFieldSelectSchema,
                      ])
                      .readonly(),
                  )
                  .readonly(),
              }),
            ),
          }),
        )
        .readonly(),
    }),
  ),
})

export type TwoColumnFormLayout = z.infer<typeof TwoColumnFormLayoutSchema>
